import { FilterOperator } from 'modules/ConceptFilterStore';
import { InitialSmartSearchState, SmartSearchState } from 'modules/InputsManager/types';
import { AnnotationStatus } from 'modules/Annotations/store/annotationsStore';
import { selectAllWorkerItem, WorkerData } from 'modules/InputsManager/models/LabelerFilterStore';
import { DefaultDisplayState, DisplayStateModalType } from 'modules/Canvas/store/canvasStore';
import { createStorageInstance } from 'utils/storage/client';
import { Concept } from 'api/grpc/resources';

export type SearchQuery = {
  /** Concept label filters */
  conceptFilters: {
    id: string;
    negate: boolean;
  }[];

  smartSearch: SmartSearchState;

  /** Operator for concept filters */
  conceptsFilterOperator: FilterOperator;

  statusFilterValue: AnnotationStatus;
  labelerFilterValue: WorkerData;
  /** Dataset ID filters */
  datasets: {
    id: string;
    negate: boolean;
  }[];

  inputTypeFilters: {
    id: string;
  }[];

  /** Metadata filters */
  metadata: string[];

  /** Unassigned Filter */
  unassignedFilter: string[];

  /** Unlabeled Filter */
  unlabeledFilter: string[];

  /** List of urls to perform visual search */
  urlSearches: string[];

  /** List of texts to perfom visual search */
  textSearches: string[];

  /** List of base64 images */
  base64: string[];

  /** Annotations Mode in the Inputs/Annotations Manager */
  isAnnotationsModeActive: boolean;
  asymmetricSearch: { selected: boolean; value: string };

  /** Brightness, Saturation, Invert Colors */
  displayStateValues: DisplayStateModalType;
  classificationPinData: Record<string, Concept>;
};

export type SearchKey = keyof SearchQuery;

export type SearchKeyArrayable =
  | 'conceptFilters'
  | 'datasets'
  | 'metadata'
  | 'unassignedFilter'
  | 'unlabeledFilter'
  | 'inputTypeFilters'
  | 'urlSearches'
  | 'textSearches'
  | 'base64';

const initialState: SearchQuery = {
  smartSearch: InitialSmartSearchState,
  conceptFilters: [],
  datasets: [],
  inputTypeFilters: [],
  metadata: [],
  urlSearches: [],
  base64: [],
  unassignedFilter: [],
  unlabeledFilter: [],
  textSearches: [],
  conceptsFilterOperator: FilterOperator.OR,
  statusFilterValue: AnnotationStatus.Any,
  labelerFilterValue: { ...selectAllWorkerItem } as WorkerData,
  isAnnotationsModeActive: false,
  asymmetricSearch: { selected: false, value: '' },
  displayStateValues: DefaultDisplayState,
  classificationPinData: {},
};

const inputSearchStorage = createStorageInstance('input-searches');

export const saveSearchToStorage: (key: string, query: SearchQuery) => Promise<SearchQuery> = (key, query) => {
  return inputSearchStorage.setItem(key, query);
};

export const fetchSearchFromStorage: (key: string) => Promise<SearchQuery> = async (key) => {
  const value = await inputSearchStorage.getItem(key);
  if (!value) return initialState;
  return value as SearchQuery;
};

export const resetSearchFromStorage = (): Promise<void> => {
  return inputSearchStorage.clear();
};
